export const REMOVE_GROWTH_PLAN_GATE = 'GrowthCoaching:RemoveGPCode';
export const RESPONSIVE_TOOLBAR = 'nav:responsiveToolbar';
export const NAV_ONBOARDING_TOURS_GATE = 'Navigation:NewNavIAForSpringSpotlight';
export const BUSINESS_UNITS_RENAME_GATE = 'MultiAccount:BusinessUnitsRename';
export const PLPO_GATE = 'ProductLedProOnboardingUnboxingFlow:SpringSpotlight';